import { render, staticRenderFns } from "./shareToGroup.vue?vue&type=template&id=55d68d22&scoped=true&"
import script from "./shareToGroup.vue?vue&type=script&lang=js&"
export * from "./shareToGroup.vue?vue&type=script&lang=js&"
import style0 from "./shareToGroup.vue?vue&type=style&index=0&id=55d68d22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d68d22",
  null
  
)

export default component.exports